module.exports = __webpack_public_path__ + "img/ltl-1.0eabc0e1.png";